import React, { useEffect, useRef } from 'react';
import './about.css'
import leftabout from './../assets/ummkulthum2.png'
import centerpaper from './../assets/back-text.png'
import rightabout from './../assets/images.png'

const About = () => {

const ref = useRef();

useEffect(() => {
  const observer = new IntersectionObserver((entries)=>{
    if(entries[0].isIntersecting){
      ref.current.classList.add("show");
    }
  });

  observer.observe(ref.current);
},[]);

return (
<section ref={ref} className="about-section">

  <img src={leftabout} className="about-left"/>

  <div className="about-paper">
    <img src={centerpaper}/>

    <div className="about-text">
      <div className="about-box">
        <h2>About Umm Kulthum</h2>

        <p>
        Umm Kulthum was one of the most legendary singers in the Arab world.
        Born in Egypt in 1904, she became a symbol of Arabic music and culture.
        </p>

        <p>
        Known as “The Star of the East”, Umm Kulthum shaped the golden age of
        Arabic music and left a timeless legacy that continues to inspire generations.
        </p>
      </div>
    </div>
  </div>

  <img src={rightabout} className="about-right"/>

</section>
);
}

export default About;